export const translations = {
  ru: {
    nav: {
      home: "Главная", about: "Обо мне", patients: "Пациентам", directions: "Направления",
      approach: "Мой подход", process: "Как проходит работа", diagnostics: "Диагностика",
      blog: "Блог", faq: "FAQ", contacts: "Контакты", book: "Записаться на консультацию",
    },
    hero: {
      slogan: "Внимательно слушать. Глубоко анализировать. Лечить осознанно.",
      title: "Ваше здоровье — это больше, чем отдельные диагнозы.",
      sub: "30+ лет клинического опыта · Несколько тысяч пациентов · Интегративный подход",
      extra: "Здоровье — это не просто отсутствие болезни. Это возможность жить с энергией, чувствовать себя хорошо и сохранять активность и интерес к жизни на долгие годы.",
      cta: "Записаться на консультацию",
      cta2: "Подробнее о первой консультации",
    },
    aboutTeaser: {
      eyebrow: "Обо мне",
      text: "Я — врач с более чем 30-летним опытом клинической практики. Функциональная медицина стала для меня следующим этапом профессионального развития, позволив объединить накопленные знания и современные научные подходы в целостную систему заботы о здоровье пациента.",
      more: "Полная биография",
    },
    about: {
      eyebrow: "Обо мне",
      title: "Tatiana Nakryzhskaya, MD, PhD, CFMP",
      role: "Врач-терапевт, врач общей практики",
      p1: "Я практикую с 1991 года. Окончила Уральский государственный медицинский университет (лечебное дело), прошла постдипломное образование по внутренней медицине, ревматологии и гемостазу. В 2000 году защитила кандидатскую диссертацию.",
      p2: "Много лет руководила отделением внутренней медицины в частной клинике и работала со сложными, коморбидными пациентами. Владею ультразвуковым исследованием внутренних органов и интерпретацией ЭКГ.",
      p3: "В 2012 году прошла нострификацию диплома в Карловом университете в Праге. В 2023 году — образование в области клинической нутрициологии, в 2026 — международную квалификацию по функциональной медицине (CFMP). Функциональная и превентивная медицина стала для меня следующим этапом профессионального развития — способом объединить многолетний клинический опыт с современными научными подходами. Особый интерес для меня представляет здоровое долголетие.",
      thought: "За каждым симптомом всегда стоит человек.",
      thought2: "Я стремлюсь понять не только отдельный симптом или диагноз, но и контекст его возникновения, взаимосвязи между состояниями и факторы, влияющие на здоровье.",
      certs_title: "Дипломы и сертификаты",
      certs_view: "Смотреть сертификат",
      creds_title: "Ключевые вехи",
      timeline: [
        { y: "1991", t: "Начало клинической практики" },
        { y: "2000", t: "Кандидат медицинских наук (PhD)" },
        { y: "2012", t: "Нострификация диплома — Карлов университет, Прага" },
        { y: "2023", t: "Образование в области клинической нутрициологии" },
        { y: "2026", t: "Международная квалификация по функциональной медицине — CFMP" },
      ],
    },
    patients: {
      eyebrow: "Пациентам",
      title: "Для каких пациентов я работаю",
      intro: "Я работаю со взрослыми пациентами — женщинами и мужчинами, без ограничения по возрасту, у которых есть сложные хронические проблемы со здоровьем.",
      list_title: "Ко мне обращаются пациенты:",
      list: [
        "с хроническими или сложными проблемами со здоровьем",
        "с несколькими хроническими состояниями одновременно",
        "когда симптомы сохраняются, а ясного объяснения их причин пока нет",
        "после обращений к нескольким специалистам, когда не хватает целостного понимания состояния здоровья",
        "за вторым медицинским мнением",
        "для персонализированной профилактики и сохранения здоровья и активности с возрастом",
      ],
      requests_title: "Частые запросы",
      requests: [
        "хроническая усталость и снижение энергии",
        "нарушения пищеварения и заболевания желудочно-кишечного тракта",
        "гормональные нарушения и изменения функции щитовидной железы",
        "нарушения менструального цикла и другие гормональные изменения",
        "избыточный вес и инсулинорезистентность",
        "нарушения сна",
        "хронический стресс и связанные с ним изменения самочувствия",
        "боли и хронические заболевания суставов и позвоночника",
        "пониженное артериальное давление",
        "некоторые аутоиммунные заболевания",
        "профилактика заболеваний и возрастных изменений",
        "поддержание здоровья и здоровое долголетие",
      ],
      special: "Отдельное внимание я уделяю здоровью женщин в пери- и менопаузе, а также вопросам профилактики и здорового старения (Longevity Medicine).",
      special2: "Моя задача — не просто стремиться к увеличению продолжительности жизни, а помогать сохранять хорошее самочувствие, ясность мышления, физическую активность и качество жизни на долгие годы.",
    },
    directions: {
      eyebrow: "Направления",
      title: "С чем я работаю",
      items: [
        { name: "Комплексная оценка здоровья", desc: "Целостная оценка состояния: анамнез, клинический осмотр, анализ имеющихся обследований и образа жизни." },
        { name: "Здоровье пищеварительной системы", desc: "Работа с нарушениями пищеварения и заболеваниями ЖКТ с учётом их связи с общим состоянием." },
        { name: "Метаболическое здоровье", desc: "Углеводный обмен, инсулинорезистентность, липидный профиль и избыточный вес — с пониманием причин." },
        { name: "Сердечно-сосудистое здоровье", desc: "Оценка факторов риска, артериального давления и состояния сосудов, профилактика осложнений." },
        { name: "Заболевания почек", desc: "Наблюдение и поддержка пациентов с хроническими заболеваниями почек." },
        { name: "Суставы и позвоночник", desc: "Ревматологический опыт: хронические боли, заболевания суставов и позвоночника, сохранение подвижности." },
        { name: "Профилактика и здоровое долголетие", desc: "Персонализированная профилактика и сохранение активности, ясности мышления и качества жизни с возрастом." },
      ],
    },
    approach: {
      eyebrow: "Мой подход",
      title: "Ваше здоровье индивидуально. Поэтому и подход должен быть индивидуальным.",
      text: "Здоровье человека невозможно понять, рассматривая только один симптом или диагноз. У каждого пациента есть своя история.",
      eval_title: "На первой консультации я оцениваю:",
      eval: ["жалобы", "историю заболеваний", "образ жизни", "питание", "физическую активность", "сон", "стресс", "принимаемые препараты", "имеющиеся результаты обследований"],
      principles: [
        { title: "Сначала слушать", text: "Понять историю пациента, его жалобы и то, что для него действительно важно." },
        { title: "Искать взаимосвязи", text: "Рассматривать симптомы и заболевания комплексно, обращая внимание на возможные причины и взаимосвязи." },
        { title: "Опираться на данные", text: "Сочетать беседу, анамнез, клинический осмотр, объективные измерения и необходимые исследования." },
        { title: "Создавать персональную стратегию", text: "Совместно определить дальнейшие шаги и план с учётом индивидуальных особенностей, возможностей и целей пациента." },
        { title: "Оценивать динамику", text: "Наблюдать за результатами и при необходимости корректировать план." },
      ],
      philosophy_title: "Философия функциональной медицины",
      philosophy_text: "Функциональная медицина — современный системный подход, рассматривающий человека как взаимосвязанную систему. Она не заменяет традиционную медицину, а дополняет её.",
      philosophy_factors: ["питание", "сон", "физическая активность", "стресс", "состояние желудочно-кишечного тракта", "метаболизм", "гормональный баланс", "взаимосвязи между системами организма"],
      philosophy_principles: [
        "Поиск причин и факторов, влияющих на состояние",
        "Целостный взгляд на организм",
        "Персонализация",
        "Долгосрочная и последовательная работа",
      ],
    },
    process: {
      eyebrow: "Как проходит работа",
      title: "Последовательно и обоснованно",
      idea: "Моя задача не просто ответить на ваши вопросы за один приём, а последовательно разобраться в причинах проблемы и выбрать наиболее обоснованную стратегию диагностики и лечения.",
      steps: [
        {
          name: "Первая консультация", time: "60 минут",
          points: [
            "обсуждаем причину обращения и основные цели",
            "подробно разбираем жалобы и историю заболеваний",
            "обсуждаем принимаемые препараты",
            "анализируем образ жизни и другие значимые факторы",
            "изучаем имеющиеся результаты исследований",
            "при необходимости проводится клинический осмотр",
            "определяем дальнейшую тактику обследования и работы",
          ],
        },
        {
          name: "Вторая консультация", time: "30 минут",
          points: [
            "анализируются все полученные данные",
            "сравниваются предыдущие исследования",
            "формируется целостное представление о состоянии",
            "обсуждаются изменения",
            "формируется индивидуальный план лечения и дальнейших действий",
            "объясняется логика предложенных рекомендаций",
          ],
        },
        {
          name: "Контрольная консультация", time: "около 40 минут",
          points: [
            "ориентировочно через месяц после второй консультации",
            "оцениваем динамику, переносимость и результаты",
            "при необходимости корректируем план",
          ],
        },
      ],
      after: "Дальнейшее наблюдение определяется индивидуально. Подход основан на доказательной медицине, актуальных клинических рекомендациях и индивидуальных особенностях пациента.",
      cta: "Записаться на приём",
    },
    diagnostics: {
      eyebrow: "Диагностика",
      title: "Технологии, которые помогают увидеть больше",
      intro: "Используются современные методы оценки состояния здоровья, которые помогают дополнить клиническую картину объективными данными. В зависимости от индивидуальной задачи могут использоваться:",
      intro_list: ["лабораторные исследования", "функциональные измерения", "оценка состава тела", "данные носимых устройств", "дополнительные специализированные исследования"],
      principle: "Я не рассматриваю отдельный показатель изолированно. Его значение определяется контекстом, взаимосвязями и динамикой.",
      groups: [
        { name: "Базовая оценка здоровья", items: ["медицинский анамнез и клиническая оценка", "артериальное давление", "частота сердечных сокращений", "антропометрические показатели", "состав тела", "лабораторные исследования по показаниям"] },
        { name: "Метаболическая оценка", items: ["стандартные лабораторные исследования", "метаболические показатели", "оценка углеводного обмена", "липидный профиль", "маркеры воспаления по показаниям", "витамины и микронутриенты по показаниям", "специализированные исследования по необходимости", "CGM — когда он действительно информативен для конкретного пациента"] },
        { name: "Сон, восстановление и физическая активность", items: ["сон", "восстановление", "HRV", "физическая активность", "тренировочная нагрузка", "кардиореспираторная форма", "реакция на физическую нагрузку"] },
        { name: "Функциональные и сосудистые измерения", items: ["дополнительные функциональные и сосудистые измерения — в зависимости от клинической задачи"] },
      ],
      lab_title: "Расширенная лабораторная диагностика",
      lab_items: ["метаболический профиль", "витамины и микронутриенты", "жирные кислоты / омега-3", "аминокислотный профиль", "гомоцистеин / метилирование", "антиоксидантная / redox-система", "гормональный профиль", "гликация / углеводный обмен", "специализированная метаболическая диагностика"],
      lab_principle: "Объём лабораторной диагностики определяется индивидуально. Я не использую универсальные панели для всех, а выбираю показатели в зависимости от целей, исходных данных и динамики состояния.",
      phrase: "Измерить. Понять. Изменить. Отследить результат.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Частые вопросы",
      items: [
        { q: "Что такое функциональная медицина?", a: "Функциональная медицина — это научно обоснованный интегративный подход, который помогает рассматривать состояние человека комплексно и обращать внимание не только на отдельный симптом, но и на возможные причины, взаимосвязи и факторы, влияющие на здоровье. Она учитывает индивидуальные особенности человека, его образ жизни, питание, сон, физическую активность, стресс и другие факторы." },
        { q: "Заменяет ли функциональная медицина традиционную?", a: "Нет. Функциональная медицина дополняет и поддерживает традиционную медицину, а не является её альтернативой." },
        { q: "Сколько длится первая консультация?", a: "60 минут. Во время первой консультации мы подробно обсуждаем состояние здоровья, историю заболеваний, жалобы, образ жизни, имеющиеся исследования и определяем дальнейшую стратегию." },
        { q: "Можно ли прийти без анализов?", a: "Да. Предварительно сдавать универсальный набор анализов не требуется. При необходимости дополнительные исследования будут определены индивидуально." },
        { q: "Можно ли получить консультацию онлайн?", a: "Да. Онлайн-консультации возможны. Первую консультацию желательно проводить очно, если для оценки состояния необходим объективный осмотр. Последующее наблюдение при необходимости может проходить онлайн." },
        { q: "Сколько длится повторная консультация?", a: "Первая консультация — 60 минут, повторная — 30 минут, контрольная — около 40 минут. Дальнейшее наблюдение определяется индивидуально." },
        { q: "Как подготовиться к первой консультации?", a: "По возможности подготовьте медицинские заключения, результаты лабораторных исследований за последние 3–6 месяцев, результаты инструментальных обследований и список принимаемых препаратов и добавок. Самостоятельно сдавать большое количество новых анализов до первой консультации не требуется." },
      ],
    },
    blog: {
      name: "The Health Journal",
      eyebrow: "Блог",
      subtitle: "Заметки о превентивной и функциональной медицине, метаболическом здоровье и здоровом долголетии.",
      empty: "Статьи скоро появятся. Следите за анонсами:",
      read: "Читать",
      min: "мин чтения",
      share: "Поделиться",
      copy: "Скопировать ссылку",
      copied: "Ссылка скопирована",
      back: "Назад к блогу",
    },
    contacts: {
      eyebrow: "Контакты",
      title: "Свяжитесь со мной",
      city_label: "Локация",
      online: "Возможны очные и онлайн-консультации.",
      form_title: "Запись на консультацию",
      form_name: "Имя и фамилия",
      form_contact: "E-mail или телефон",
      form_service: "Тип консультации",
      form_message: "Коротко о вашем запросе (необязательно)",
      form_send: "Отправить заявку",
      form_success: "Спасибо! Я свяжусь с вами в ближайшее время.",
      form_error: "Не удалось отправить. Попробуйте ещё раз.",
      consult_types: ["Первая консультация — 60 минут", "Вторая консультация — 30 минут", "Контрольная консультация — около 40 минут", "Онлайн-консультация"],
    },
    contactform: {
      title: "Написать мне",
      subtitle: "Вопрос, не связанный с записью? Напишите здесь — письмо придёт мне прямо на почту.",
      name: "Имя",
      email: "Ваш e-mail",
      message: "Сообщение",
      send: "Отправить",
      success: "Сообщение отправлено! Отвечу вам в ближайшее время.",
      error: "Не удалось отправить. Напишите напрямую: info@tatiananakryzhskaya.com",
    },
    booking: {
      title: "Запись на консультацию",
      subtitle: "Выберите удобные дату и время в календаре ниже.",
      ifmv_or: "или",
      ifmv_cta: "Записаться в Институт функциональной медицины и питания (IFMV)",
    },
    finalCta: {
      title: "Готовы по-другому взглянуть на своё здоровье?",
      text: "Первый шаг простой: на первой консультации мы спокойно и подробно разберём ваше состояние и определим понятную стратегию дальнейшей работы.",
      cta: "Записаться на консультацию",
      cta2: "Подробнее о первой консультации",
    },
    cookies: {
      banner_title: "Cookies",
      banner_text: "Мы используем необходимые cookies для работы сайта. С вашего согласия — также аналитические (Microsoft Clarity), чтобы понимать, как посетители пользуются сайтом. Рекламное отслеживание не используется.",
      accept: "Принять необязательные cookies",
      reject: "Отклонить необязательные cookies",
      settings: "Настройки",
      settings_title: "Настройки cookies",
      necessary: "Необходимые",
      necessary_desc: "Обеспечивают работу сайта. Всегда активны.",
      analytics: "Аналитические",
      analytics_desc: "Microsoft Clarity: анонимная статистика посещений и тепловые карты.",
      advertising: "Рекламные",
      advertising_desc: "Не используются на этом сайте.",
      save: "Сохранить выбор",
    },
    footer: {
      tagline: "Превентивная и функциональная медицина в Праге. Клинический опыт с 1991 года.",
      cookie_settings: "Настройки cookies",
      nav_title: "Навигация",
      contact_title: "Контакты",
      follow: "Соцсети",
      rights: "© 2026 Tatiana Nakryzhskaya, MD, PhD, CFMP. Все права защищены.",
      note: "Информация на сайте носит справочный характер и не заменяет консультацию врача.",
    },
    seo: {
      home: { title: "Tatiana Nakryzhskaya, MD, PhD, CFMP — превентивная и функциональная медицина в Праге", desc: "Врач внутренней медицины и ревматологии, 30+ лет клинического опыта. Превентивная и функциональная медицина в Праге: комплексная оценка здоровья, метаболика, здоровое долголетие." },
      about: { title: "Обо мне — Tatiana Nakryzhskaya, MD, PhD, CFMP", desc: "Врач с 1991 года. Внутренняя медицина, ревматология, PhD (2000), CFMP (2026). Клинический опыт и функциональный подход." },
      blog: { title: "The Health Journal — блог о превентивной медицине", desc: "Заметки врача о превентивной и функциональной медицине, метаболическом здоровье и здоровом долголетии." },
      contacts: { title: "Контакты и запись — Tatiana Nakryzhskaya, Прага", desc: "Запись на первую консультацию (60 минут). Очные и онлайн-консультации в Праге." },
    },
  },

  en: {
    nav: {
      home: "Home", about: "About me", patients: "For patients", directions: "Areas of focus",
      approach: "My approach", process: "How we work", diagnostics: "Diagnostics",
      blog: "Blog", faq: "FAQ", contacts: "Contact", book: "Book a consultation",
    },
    hero: {
      slogan: "Listen carefully. Analyse deeply. Treat consciously.",
      title: "Your health is more than a set of separate diagnoses.",
      sub: "30+ years of clinical experience · Several thousand patients · An integrative approach",
      extra: "Health is not simply the absence of disease. It is the ability to live with energy, to feel well, and to keep your activity and interest in life for many years.",
      cta: "Book a consultation",
      cta2: "More about the first consultation",
    },
    aboutTeaser: {
      eyebrow: "About me",
      text: "I am a physician with more than 30 years of clinical practice. Functional medicine became the next stage of my professional development — a way to unite the knowledge I have accumulated with modern scientific approaches into a coherent system of care for my patients.",
      more: "Full biography",
    },
    about: {
      eyebrow: "About me",
      title: "Tatiana Nakryzhskaya, MD, PhD, CFMP",
      role: "Physician of internal medicine and rheumatology",
      p1: "I have practised medicine since 1991. I graduated from Ural State Medical University (general medicine) and completed postgraduate training in internal medicine, rheumatology and hemostasis. In 2000 I defended my doctoral thesis (Candidate of Medical Sciences / PhD).",
      p2: "For many years I headed the internal medicine department of a private clinic, working with complex, comorbid patients. My clinical skills include ultrasound examination of internal organs and ECG interpretation.",
      p3: "In 2012 my medical diploma was officially recognized at Charles University in Prague. In 2023 I completed education in nutrition counseling, and in 2026 — the international qualification in functional medicine (CFMP). Preventive and functional medicine became the next stage of my professional development — a way to unite decades of clinical experience with modern scientific approaches. Healthy longevity is a particular interest of mine.",
      thought: "Behind every symptom there is always a person.",
      thought2: "I strive to understand not only a single symptom or diagnosis, but the context in which it appeared, the connections between conditions, and the factors that influence health.",
      certs_title: "Diplomas & certificates",
      certs_view: "View certificate",
      creds_title: "Key milestones",
      timeline: [
        { y: "1991", t: "Start of clinical practice" },
        { y: "2000", t: "Candidate of Medical Sciences (PhD)" },
        { y: "2012", t: "Diploma recognition — Charles University, Prague" },
        { y: "2023", t: "Education in clinical nutrition" },
        { y: "2026", t: "International qualification in functional medicine — CFMP" },
      ],
    },
    patients: {
      eyebrow: "For patients",
      title: "Who I work with",
      intro: "I work with adult patients — women and men of any age — who face complex chronic health problems.",
      list_title: "Patients come to me:",
      list: [
        "with chronic or complex health problems",
        "with several chronic conditions at the same time",
        "when symptoms persist but their cause is not yet clear",
        "after seeing several specialists, when a coherent view of their health is missing",
        "for a second medical opinion",
        "for personalized prevention and for preserving health and activity with age",
      ],
      requests_title: "Common concerns",
      requests: [
        "chronic fatigue and low energy",
        "digestive disorders and gastrointestinal diseases",
        "hormonal imbalances and thyroid function changes",
        "menstrual cycle irregularities and other hormonal changes",
        "excess weight and insulin resistance",
        "sleep disturbances",
        "chronic stress and related changes in wellbeing",
        "pain and chronic diseases of joints and spine",
        "low blood pressure",
        "certain autoimmune conditions",
        "prevention of disease and age-related changes",
        "maintaining health and healthy longevity",
      ],
      special: "I pay special attention to women's health in peri- and menopause, and to prevention and healthy aging (Longevity Medicine).",
      special2: "My goal is not simply to extend lifespan, but to help preserve good wellbeing, clarity of mind, physical activity and quality of life for many years.",
    },
    directions: {
      eyebrow: "Areas of focus",
      title: "What I work with",
      items: [
        { name: "Comprehensive health assessment", desc: "A whole-person evaluation: medical history, clinical examination, review of existing test results and lifestyle." },
        { name: "Digestive health", desc: "Working with digestive disorders and gastrointestinal diseases in the context of overall health." },
        { name: "Metabolic health", desc: "Carbohydrate metabolism, insulin resistance, lipid profile and excess weight — with an understanding of causes." },
        { name: "Cardiovascular health", desc: "Assessment of risk factors, blood pressure and vascular condition; prevention of complications." },
        { name: "Kidney diseases", desc: "Monitoring and supporting patients with chronic kidney conditions in connection with overall health." },
        { name: "Joints and spine", desc: "Rheumatology experience: chronic pain, joint and spine diseases, preserving mobility." },
        { name: "Prevention & healthy longevity", desc: "Personalized prevention, preserving activity, clarity of mind and quality of life with age." },
      ],
    },
    approach: {
      eyebrow: "My approach",
      title: "Your health is individual. So the approach must be individual too.",
      text: "A person's health cannot be understood by looking at a single symptom or diagnosis. Every patient has their own story.",
      eval_title: "At the first consultation I assess:",
      eval: ["complaints", "medical history", "lifestyle", "nutrition", "physical activity", "sleep", "stress", "current medications", "existing test results"],
      principles: [
        { title: "Listen first", text: "Understand the patient's story, their complaints, and what truly matters to them." },
        { title: "Look for connections", text: "View symptoms and diseases comprehensively, paying attention to possible causes and relationships." },
        { title: "Rely on data", text: "Combine conversation, history, clinical examination, objective measurements and necessary investigations." },
        { title: "Build a personal strategy", text: "Define next steps and a plan together, based on the patient's individual characteristics, possibilities and goals." },
        { title: "Track progress", text: "Monitor results and adjust the plan when needed." },
      ],
      philosophy_title: "The philosophy of functional medicine",
      philosophy_text: "Functional medicine is a modern systems approach that views a person as an interconnected system. It does not replace conventional medicine — it complements it.",
      philosophy_factors: ["nutrition", "sleep", "physical activity", "stress", "gastrointestinal health", "metabolism", "hormonal balance", "connections between body systems"],
      philosophy_principles: [
        "Searching for causes and factors influencing the condition",
        "A whole-body view",
        "Personalization",
        "Long-term, consistent work",
      ],
    },
    process: {
      eyebrow: "How we work",
      title: "Step by step, based on evidence",
      idea: "My task is not simply to answer your questions in a single visit, but to consistently understand the causes of the problem and choose the most well-grounded strategy for diagnostics and treatment.",
      steps: [
        {
          name: "First consultation", time: "60 minutes",
          points: [
            "we discuss the reason for your visit and your main goals",
            "we review your complaints and medical history in detail",
            "we discuss the medications you take",
            "we analyse lifestyle and other significant factors",
            "we study your existing test results",
            "a clinical examination is performed if needed",
            "we define the further diagnostic and treatment strategy",
          ],
        },
        {
          name: "Second consultation", time: "30 minutes",
          points: [
            "all received data is analysed",
            "previous investigations are compared",
            "a coherent picture of your condition is formed",
            "changes are discussed",
            "an individual treatment and action plan is created",
            "the logic behind the recommendations is explained",
          ],
        },
        {
          name: "Follow-up consultation", time: "about 40 minutes",
          points: [
            "approximately one month after the second consultation",
            "we assess progress, tolerance and results",
            "the plan is adjusted if needed",
          ],
        },
      ],
      after: "Further monitoring is determined individually. The approach is based on evidence-based medicine, current clinical guidelines and the individual characteristics of the patient.",
      cta: "Book an appointment",
    },
    diagnostics: {
      eyebrow: "Diagnostics",
      title: "Technologies that help us see more",
      intro: "Modern methods of health assessment help complement the clinical picture with objective data. Depending on the individual task, the following may be used:",
      intro_list: ["laboratory testing", "functional measurements", "body composition analysis", "data from wearable devices", "additional specialized investigations"],
      principle: "I never interpret a single marker in isolation. Its meaning is defined by context, connections and dynamics.",
      groups: [
        { name: "Basic health assessment", items: ["medical history and clinical evaluation", "blood pressure", "heart rate", "anthropometric indicators", "body composition", "laboratory tests when indicated"] },
        { name: "Metabolic assessment", items: ["standard laboratory tests", "metabolic markers", "carbohydrate metabolism assessment", "lipid profile", "inflammatory markers when indicated", "vitamins and micronutrients when indicated", "specialized investigations when needed", "CGM — when it is genuinely informative for the specific patient"] },
        { name: "Sleep, recovery & physical activity", items: ["sleep", "recovery", "HRV", "physical activity", "training load", "cardio endurance", "response to physical exertion"] },
        { name: "Functional & vascular measurements", items: ["additional functional and vascular measurements — depending on the clinical task"] },
      ],
      lab_title: "Extended laboratory diagnostics",
      lab_items: ["metabolic profile", "vitamins and micronutrients", "fatty acids / omega-3", "amino acid profile", "homocysteine / methylation", "antioxidant / redox system", "hormonal profile", "glycation / carbohydrate metabolism", "specialized metabolic diagnostics"],
      lab_principle: "The scope of laboratory diagnostics is determined individually. I do not use universal panels for everyone — markers are selected based on goals, baseline data and the dynamics of the condition.",
      phrase: "Measure. Understand. Change. Track the result.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "What is functional medicine?", a: "Functional medicine is an evidence-based integrative approach that views a person's health comprehensively, paying attention not only to an individual symptom but also to possible causes, connections and factors that influence health. It takes into account a person's individual characteristics, lifestyle, nutrition, sleep, physical activity, stress and other factors." },
        { q: "Does functional medicine replace conventional medicine?", a: "No. Functional medicine complements and supports conventional medicine — it is not an alternative to it." },
        { q: "How long is the first consultation?", a: "60 minutes. During the first consultation we discuss your health in detail: medical history, complaints, lifestyle, existing test results — and define the further strategy." },
        { q: "Can I come without lab tests?", a: "Yes. You do not need to complete a universal set of tests beforehand. If needed, additional investigations will be determined individually." },
        { q: "Are online consultations possible?", a: "Yes. Online consultations are possible. The first consultation is preferably held in person if an objective examination is needed to assess your condition. Further follow-up can take place online when appropriate." },
        { q: "How long are follow-up consultations?", a: "The first consultation is 60 minutes, the second is 30 minutes, and a follow-up is about 40 minutes. Further monitoring is determined individually." },
        { q: "How should I prepare for the first consultation?", a: "If possible, prepare your medical reports, laboratory results from the last 3–6 months, results of instrumental examinations, and a list of medications and supplements you take. You do not need to take a large number of new tests before the first consultation." },
      ],
    },
    blog: {
      name: "The Health Journal",
      eyebrow: "Blog",
      subtitle: "Notes on preventive and functional medicine, metabolic health and healthy longevity.",
      empty: "Articles are coming soon. Follow the announcements:",
      read: "Read",
      min: "min read",
      share: "Share",
      copy: "Copy link",
      copied: "Link copied",
      back: "Back to the blog",
    },
    contacts: {
      eyebrow: "Contact",
      title: "Get in touch",
      city_label: "Location",
      online: "In-person and online consultations are available.",
      form_title: "Book a consultation",
      form_name: "Full name",
      form_contact: "E-mail or phone",
      form_service: "Consultation type",
      form_message: "Briefly about your concern (optional)",
      form_send: "Send request",
      form_success: "Thank you! I will get back to you shortly.",
      form_error: "Sending failed. Please try again.",
      consult_types: ["First consultation — 60 minutes", "Second consultation — 30 minutes", "Follow-up consultation — about 40 minutes", "Online consultation"],
    },
    contactform: {
      title: "Write to me",
      subtitle: "A question not related to booking? Write here — the message goes straight to my inbox.",
      name: "Name",
      email: "Your e-mail",
      message: "Message",
      send: "Send",
      success: "Message sent! I will reply to you shortly.",
      error: "Sending failed. Please write directly to info@tatiananakryzhskaya.com",
    },
    booking: {
      title: "Book a consultation",
      subtitle: "Choose a convenient date and time in the calendar below.",
      ifmv_or: "or",
      ifmv_cta: "Book at the Institute of Functional Medicine and Nutrition (IFMV)",
    },
    finalCta: {
      title: "Ready to look at your health differently?",
      text: "The first step is simple: at the first consultation we will calmly and thoroughly review your condition and define a clear strategy for further work.",
      cta: "Book a consultation",
      cta2: "More about the first consultation",
    },
    cookies: {
      banner_title: "Cookies",
      banner_text: "We use necessary cookies to make the site work. With your consent we also use analytics cookies (Microsoft Clarity) to understand how visitors use the site. No advertising tracking is used.",
      accept: "Accept optional cookies",
      reject: "Reject optional cookies",
      settings: "Settings",
      settings_title: "Cookie settings",
      necessary: "Necessary",
      necessary_desc: "Required for the website to function. Always active.",
      analytics: "Analytics",
      analytics_desc: "Microsoft Clarity: anonymous visit statistics and heatmaps.",
      advertising: "Advertising",
      advertising_desc: "Not used on this website.",
      save: "Save preferences",
    },
    footer: {
      tagline: "Preventive and functional medicine in Prague. Clinical experience since 1991.",
      cookie_settings: "Cookie settings",
      nav_title: "Navigation",
      contact_title: "Contact",
      follow: "Social",
      rights: "© 2026 Tatiana Nakryzhskaya, MD, PhD, CFMP. All rights reserved.",
      note: "The information on this website is for reference only and does not replace a medical consultation.",
    },
    seo: {
      home: { title: "Tatiana Nakryzhskaya, MD, PhD, CFMP — Preventive & Functional Medicine in Prague", desc: "Physician of internal medicine and rheumatology with 30+ years of clinical experience. Preventive and functional medicine in Prague: comprehensive health assessment, metabolic health, healthy longevity." },
      about: { title: "About — Tatiana Nakryzhskaya, MD, PhD, CFMP", desc: "Physician since 1991. Internal medicine, rheumatology, PhD (2000), CFMP (2026). Clinical experience combined with a functional approach." },
      blog: { title: "The Health Journal — notes on preventive medicine", desc: "A physician's notes on preventive and functional medicine, metabolic health and healthy longevity." },
      contacts: { title: "Contact & booking — Tatiana Nakryzhskaya, Prague", desc: "Book a first consultation (60 minutes). In-person and online consultations in Prague." },
    },
  },

  cs: {
    nav: {
      home: "Domů", about: "O mně", patients: "Pro pacienty", directions: "Oblasti práce",
      approach: "Můj přístup", process: "Průběh spolupráce", diagnostics: "Diagnostika",
      blog: "Blog", faq: "FAQ", contacts: "Kontakty", book: "Objednat se na konzultaci",
    },
    hero: {
      slogan: "Pozorně naslouchat. Hluboce analyzovat. Léčit vědomě.",
      title: "Vaše zdraví je víc než jednotlivé diagnózy.",
      sub: "30+ let klinické praxe · Několik tisíc pacientů · Integrativní přístup",
      extra: "Zdraví není jen absence nemoci. Je to možnost žít s energií, cítit se dobře a uchovat si aktivitu a radost ze života na dlouhá léta.",
      cta: "Objednat se na konzultaci",
      cta2: "Více o první konzultaci",
    },
    aboutTeaser: {
      eyebrow: "O mně",
      text: "Jsem lékařka s více než 30 lety klinické praxe. Funkční medicína se pro mě stala dalším krokem profesního rozvoje — umožnila mi propojit dlouholeté zkušenosti s moderními vědeckými poznatky a vytvořit komplexní a individuální přístup k péči o zdraví pacienta.",
      more: "Úplný životopis",
    },
    about: {
      eyebrow: "O mně",
      title: "Tatiana Nakryzhskaya, MD, PhD, CFMP",
      role: "Lékařka v oboru vnitřního lékařství a revmatologie",
      p1: "Praktikuji od roku 1991. Vystudovala jsem Ural State Medical University (obor všeobecné lékařství) a absolvovala postgraduální vzdělání v oboru vnitřního lékařství, revmatologie a hemostázy. V roce 2000 jsem obhájila kandidátskou dizertaci.",
      p2: "Dlouhá léta jsem vedla oddělení vnitřního lékařství v soukromé klinice a pracovala se složitými, komorbidními pacienty. Klasickou medicínu kombinuji s individuálním moderním přístupem k pacientovi. Mám zkušenosti s ultrazvukovým vyšetřením vnitřních orgánů a interpretací EKG.",
      p3: "V roce 2012 proběhla nostrifikace mého lékařského diplomu na Univerzitě Karlově v Praze. V roce 2023 jsem absolvovala vzdělání výživového poradce a v roce 2026 mezinárodní kvalifikaci ve funkční medicíně (CFMP). Preventivní a funkční medicína se pro mě stala dalším krokem profesního rozvoje — spojením dlouholeté klinické zkušenosti s moderními vědeckými přístupy. Zvláštní zájem věnuji zdravému stárnutí.",
      thought: "Za každým příznakem stojí vždy člověk.",
      thought2: "Snažím se porozumět nejen jednotlivému příznaku či diagnóze, ale i kontextu jeho vzniku, souvislostem mezi stavy a faktorům, které zdraví ovlivňují.",
      certs_title: "Diplomy a certifikáty",
      certs_view: "Zobrazit certifikát",
      creds_title: "Klíčové milníky",
      timeline: [
        { y: "1991", t: "Začátek klinické praxe" },
        { y: "2000", t: "Kandidátka lékařských věd (PhD)" },
        { y: "2012", t: "Nostrifikace diplomu — Univerzita Karlova, Praha" },
        { y: "2023", t: "Vzdělání výživového poradce" },
        { y: "2026", t: "Mezinárodní kvalifikace ve funkční medicíně — CFMP" },
      ],
    },
    patients: {
      eyebrow: "Pro pacienty",
      title: "Pro které pacienty pracuji",
      intro: "Pracuji s dospělými pacienty — ženami i muži, bez věkového omezení — kteří mají složité chronické zdravotní problémy.",
      list_title: "Pacienti ke mně přicházejí:",
      list: [
        "s chronickými nebo složitými zdravotními problémy",
        "s několika chronickými stavy současně",
        "když příznaky přetrvávají, ale jejich příčina zatím není jasná",
        "po návštěvě několika specialistů, kdy chybí celostní pohled na zdraví",
        "pro druhý lékařský názor",
        "pro individuální prevenci a zachování zdraví a aktivity s věkem",
      ],
      requests_title: "Časté důvody návštěvy",
      requests: [
        "chronická únava a pokles energie",
        "poruchy trávení a onemocnění zažívacího traktu",
        "hormonální poruchy a změny funkce štítné žlázy",
        "poruchy menstruačního cyklu a další hormonální změny",
        "nadváha a inzulínová rezistence",
        "poruchy spánku",
        "chronický stres a s ním spojené změny pohody",
        "bolesti a chronická onemocnění kloubů a páteře",
        "nízký krevní tlak",
        "některá autoimunitní onemocnění",
        "prevence nemocí a změn souvisejících s věkem",
        "udržení zdraví a zdravé stárnutí",
      ],
      special: "Zvláštní pozornost věnuji zdraví žen v období peri- a menopauzy a otázkám prevence a zdravého stárnutí (Longevity Medicine).",
      special2: "Mým cílem není jen prodlužovat délku života, ale pomáhat uchovat dobrou pohodu, jasné myšlení, fyzickou aktivitu a kvalitu života na dlouhá léta.",
    },
    directions: {
      eyebrow: "Oblasti práce",
      title: "S čím pracuji",
      items: [
        { name: "Komplexní hodnocení zdraví", desc: "Celostní hodnocení stavu: anamnéza, klinické vyšetření, rozbor dosavadních výsledků a životního stylu." },
        { name: "Zdraví trávicí soustavy", desc: "Práce s poruchami trávení a onemocněními zažívacího traktu s ohledem na jejich souvislost s celkovým stavem." },
        { name: "Metabolické zdraví", desc: "Sacharidový metabolismus, inzulínová rezistence, lipidový profil a nadváha — s porozuměním příčinám." },
        { name: "Kardiovaskulární zdraví", desc: "Hodnocení rizikových faktorů, krevního tlaku a stavu cév, prevence komplikací." },
        { name: "Onemocnění ledvin", desc: "Sledování a podpora pacientů s chronickými onemocněními ledvin v souvislosti s celkovým zdravím." },
        { name: "Klouby a páteř", desc: "Revmatologické zkušenosti: chronické bolesti, onemocnění kloubů a páteře, zachování pohyblivosti." },
        { name: "Prevence a zdravé stárnutí", desc: "Personalizovaná prevence a zachování aktivity, jasného myšlení a kvality života s věkem." },
      ],
    },
    approach: {
      eyebrow: "Můj přístup",
      title: "Vaše zdraví je individuální. Proto i přístup musí být individuální.",
      text: "Zdraví člověka nelze pochopit pouze z jednoho příznaku nebo diagnózy. Každý pacient má svůj příběh.",
      eval_title: "Na první konzultaci hodnotím:",
      eval: ["stížnosti", "historii onemocnění", "životní styl", "výživu", "fyzickou aktivitu", "spánek", "stres", "užívané léky", "dosavadní výsledky vyšetření"],
      principles: [
        { title: "Nejdřív naslouchat", text: "Pochopit příběh pacienta, jeho stížnosti a to, co je pro něj skutečně důležité." },
        { title: "Hledat souvislosti", text: "Vnímat příznaky a onemocnění komplexně, s pozorností k možným příčinám a vazbám." },
        { title: "Opírat se o data", text: "Spojovat rozhovor, anamnézu, klinické vyšetření, objektivní měření a potřebná vyšetření." },
        { title: "Vytvořit osobní strategii", text: "Společně určit další kroky a plán s ohledem na individuální možnosti a cíle pacienta." },
        { title: "Hodnotit vývoj", text: "Sledovat výsledky a v případě potřeby plán upravit." },
      ],
      philosophy_title: "Filosofie funkční medicíny",
      philosophy_text: "Funkční medicína je moderní systémový přístup, který vnímá člověka jako vzájemně propojený systém. Nenahrazuje klasickou medicínu — doplňuje ji.",
      philosophy_factors: ["výživa", "spánek", "fyzická aktivita", "stres", "stav zažívacího traktu", "metabolismus", "hormonální rovnováha", "vazby mezi systémy organismu"],
      philosophy_principles: [
        "Hledání příčin a faktorů ovlivňujících stav",
        "Celostní pohled na organismus",
        "Personalizace",
        "Dlouhodobá a postupná práce",
      ],
    },
    process: {
      eyebrow: "Průběh spolupráce",
      title: "Postupně a na základě důkazů",
      idea: "Mým úkolem není jen odpovědět na vaše otázky během jedné návštěvy, ale postupně pochopit příčiny problému a zvolit nejlépe podloženou strategii diagnostiky a léčby.",
      steps: [
        {
          name: "První konzultace", time: "60 minut",
          points: [
            "probíráme důvod návštěvy a hlavní cíle",
            "podrobně rozebíráme stížnosti a historii onemocnění",
            "probíráme užívané léky",
            "analyzujeme životní styl a další významné faktory",
            "studujeme dosavadní výsledky vyšetření",
            "v případě potřeby provádím klinické vyšetření",
            "určujeme další taktiku vyšetření a spolupráce",
          ],
        },
        {
          name: "Druhá konzultace", time: "30 minut",
          points: [
            "analyzujeme všechna získaná data",
            "porovnáváme předchozí vyšetření",
            "vytváříme celostní představu o stavu",
            "probíráme změny",
            "vytváříme individuální plán léčby a dalších kroků",
            "vysvětluji logiku navržených doporučení",
          ],
        },
        {
          name: "Kontrolní konzultace", time: "cca 40 minut",
          points: [
            "přibližně měsíc po druhé konzultaci",
            "hodnotíme vývoj, snášenlivost a výsledky",
            "v případě potřeby plán upravujeme",
          ],
        },
      ],
      after: "Další sledování je individuální. Přístup vychází z medicíny založené na důkazech, aktuálních klinických doporučení a individuálních vlastností pacienta.",
      cta: "Objednat se na konzultaci",
    },
    diagnostics: {
      eyebrow: "Diagnostika",
      title: "Technologie, které pomáhají vidět víc",
      intro: "Využívám moderní metody hodnocení zdraví, které doplňují klinický obraz o objektivní data. Podle individuálního úkolu lze použít:",
      intro_list: ["laboratorní vyšetření", "funkční měření", "hodnocení tělesného složení", "data z nositelných zařízení", "další specializovaná vyšetření"],
      principle: "Nehodnotím jednotlivý ukazatel izolovaně. Jeho význam určuje kontext, souvislosti a vývoj.",
      groups: [
        { name: "Základní hodnocení zdraví", items: ["lékařská anamnéza a klinické hodnocení", "krevní tlak", "tepová frekvence", "antropometrické ukazatele", "tělesné složení", "laboratorní vyšetření dle indikace"] },
        { name: "Metabolické hodnocení", items: ["standardní laboratorní vyšetření", "metabolické ukazatele", "hodnocení sacharidového metabolismu", "lipidový profil", "markery zánětu dle indikace", "vitamíny a mikronutrienty dle indikace", "specializovaná vyšetření dle potřeby", "CGM — pokud je pro konkrétního pacienta skutečně informativní"] },
        { name: "Spánek, regenerace a fyzická aktivita", items: ["spánek", "regenerace", "HRV", "fyzická aktivita", "tréninková zátěž", "kardiorespirační kondice", "reakce na fyzickou zátěž"] },
        { name: "Funkční a vaskulární měření", items: ["další funkční a cévní měření — podle klinické úlohy"] },
      ],
      lab_title: "Rozšířená laboratorní diagnostika",
      lab_items: ["metabolický profil", "vitamíny a mikronutrienty", "mastné kyseliny / omega-3", "aminokyselinový profil", "homocystein / methylace", "antioxidantní / redox systém", "hormonální profil", "glykace / sacharidový metabolismus", "specializovaná metabolická diagnostika"],
      lab_principle: "Rozsah laboratorní diagnostiky určuji individuálně. Nepoužívám univerzální panely pro všechny — ukazatele vybírám podle cílů, výchozích dat a vývoje stavu.",
      phrase: "Změřit. Pochopit. Změnit. Sledovat výsledek.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Časté otázky",
      items: [
        { q: "Co je funkční medicína?", a: "Funkční medicína je vědecky podložený integrativní přístup, který pomáhá vnímat stav člověka komplexně a věnovat pozornost nejen jednotlivému příznaku, ale i možným příčinám, souvislostem a faktorům ovlivňujícím zdraví. Zohledňuje individuální vlastnosti člověka, jeho životní styl, výživu, spánek, fyzickou aktivitu, stres a další faktory." },
        { q: "Nahrazuje funkční medicína klasickou?", a: "Ne. Funkční medicína klasickou medicínu doplňuje a podporuje — není její alternativou." },
        { q: "Jak dlouho trvá první konzultace?", a: "60 minut. Během první konzultace podrobně probíráme váš zdravotní stav, historii onemocnění, stížnosti, životní styl a dosavadní vyšetření a určujeme další strategii." },
        { q: "Mohu přijít bez testů?", a: "Ano. Předem není nutné absolvovat univerzální sadu testů. V případě potřeby budou další vyšetření určena individuálně." },
        { q: "Je možná online konzultace?", a: "Ano. Online konzultace jsou možné. První konzultace je vhodné provést osobně, pokud je k hodnocení stavu potřebné objektivní vyšetření. Další sledování může probíhat online." },
        { q: "Jak dlouho trvá kontrolní konzultace?", a: "První konzultace — 60 minut, druhá konzultace — 30 minut, kontrolní konzultace — cca 40 minut. Další sledování je individuální." },
        { q: "Jak se připravit na první konzultaci?", a: "Pokud možno si připravte lékařské zprávy, výsledky laboratorních vyšetření za posledních 3–6 měsíců, výsledky instrumentálních vyšetření a seznam užívaných léků a doplňků. Před první konzultací není nutné samostatně absolvovat velké množství nových testů." },
      ],
    },
    blog: {
      name: "The Health Journal",
      eyebrow: "Blog",
      subtitle: "Poznámky o preventivní a funkční medicíně, metabolickém zdraví a zdravém stárnutí.",
      empty: "Články se brzy objeví. Sledujte oznámení:",
      read: "Číst",
      min: "min čtení",
      share: "Sdílet",
      copy: "Zkopírovat odkaz",
      copied: "Odkaz zkopírován",
      back: "Zpět na blog",
    },
    contacts: {
      eyebrow: "Kontakty",
      title: "Spojte se se mnou",
      city_label: "Lokalita",
      online: "Možné jsou osobní i online konzultace.",
      form_title: "Objednání na konzultaci",
      form_name: "Jméno a příjmení",
      form_contact: "E-mail nebo telefon",
      form_service: "Typ konzultace",
      form_message: "Stručně k vašemu dotazu (nepovinné)",
      form_send: "Odeslat poptávku",
      form_success: "Děkuji! Ozvu se vám co nejdříve.",
      form_error: "Odeslání se nezdařilo. Zkuste to prosím znovu.",
      consult_types: ["První konzultace — 60 minut", "Druhá konzultace — 30 minut", "Kontrolní konzultace — cca 40 minut", "Online konzultace"],
    },
    contactform: {
      title: "Napište mi",
      subtitle: "Otázka, která se netýká objednání? Napište zde — zpráva dorazí přímo do mé schránky.",
      name: "Jméno",
      email: "Váš e-mail",
      message: "Zpráva",
      send: "Odeslat",
      success: "Zpráva odeslána! Ozvu se vám co nejdříve.",
      error: "Odeslání se nezdařilo. Napište prosím přímo na info@tatiananakryzhskaya.com",
    },
    booking: {
      title: "Objednání na konzultaci",
      subtitle: "Vyberte si vhodný termín v kalendáři níže.",
      ifmv_or: "nebo",
      ifmv_cta: "Objednat se v Institutu funkční medicíny a výživy (IFMV)",
    },
    finalCta: {
      title: "Jste připraveni podívat se na své zdraví jinak?",
      text: "První krok je jednoduchý: na první konzultaci klidně a podrobně projdeme váš stav a určíme srozumitelnou strategii další spolupráce.",
      cta: "Objednat se na konzultaci",
      cta2: "Více o první konzultaci",
    },
    cookies: {
      banner_title: "Cookies",
      banner_text: "Používáme nezbytné cookies pro fungování webu. S vaším souhlasem také analytické cookies (Microsoft Clarity), abychom rozuměli, jak návštěvníci web používají. Reklamní sledování nepoužíváme.",
      accept: "Přijmout volitelné cookies",
      reject: "Odmítnout volitelné cookies",
      settings: "Nastavení",
      settings_title: "Nastavení cookies",
      necessary: "Nezbytné",
      necessary_desc: "Zajišťují fungování webu. Vždy aktivní.",
      analytics: "Analytické",
      analytics_desc: "Microsoft Clarity: anonymní statistiky návštěvnosti a mapy kliků.",
      advertising: "Reklamní",
      advertising_desc: "Na tomto webu se nepoužívají.",
      save: "Uložit výběr",
    },
    footer: {
      tagline: "Preventivní a funkční medicína v Praze. Klinická praxe od roku 1991.",
      cookie_settings: "Nastavení cookies",
      nav_title: "Navigace",
      contact_title: "Kontakt",
      follow: "Sociální sítě",
      rights: "© 2026 Tatiana Nakryzhskaya, MD, PhD, CFMP. Všechna práva vyhrazena.",
      note: "Informace na webu mají pouze informativní charakter a nenahrazují lékařskou konzultaci.",
    },
    seo: {
      home: { title: "Tatiana Nakryzhskaya, MD, PhD, CFMP — preventivní a funkční medicína v Praze", desc: "Lékařka vnitřního lékařství a revmatologie s více než 30 lety klinické praxe. Preventivní a funkční medicína v Praze: komplexní hodnocení zdraví, metabolické zdraví, zdravé stárnutí." },
      about: { title: "O mně — Tatiana Nakryzhskaya, MD, PhD, CFMP", desc: "Lékařka od roku 1991. Vnitřní lékařství, revmatologie, kandidátka lékařských věd (2000), CFMP (2026). Klinická zkušenost spojená s funkčním přístupem." },
      blog: { title: "The Health Journal — poznámky o preventivní medicíně", desc: "Poznámky lékařky o preventivní a funkční medicíně, metabolickém zdraví a zdravém stárnutí." },
      contacts: { title: "Kontakt a objednání — Tatiana Nakryzhskaya, Praha", desc: "Objednání na první konzultaci (60 minut). Osobní i online konzultace v Praze." },
    },
  },
};
